import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  TextField,
  Typography,
  Button,
  Grid,
  Paper,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import axios from "axios";
// import { analytics } from './../../firebase';
import Appbar from "./../Appbar";
import {
  productInfo,
  ProductType,
  Message,
  storeDataLocally,
  ADD_PRODUCT_URL,
} from "./../../constants";
import { useSelector } from "react-redux";

import { useForm } from "react-hook-form";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column"
  },
  main: {
    flex: 1,
    padding: theme.spacing(6, 4),
    background: '#eaeff1',
  },
  paper: {
    maxWidth: 700,
    margin: 'auto',
    overflow: 'hidden',
  },
  link: {
    textDecoration: "none"
  },
  searchBar: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
  contentWrapper: {
    margin: '40px 16px',
  },
  back: {
    marginRight: theme.spacing(1),
  },
  align: {
    marginLeft: theme.spacing(2)
  },
  input: {
      display: 'none',
    },
}));

const AddProduct = () => {
  const [product, setProduct] = useState<ProductType>({
    name: "",
    brand: "",
    category: "",
    price: ""
  });
  const [image, setImage] = useState<any>("");
  const [message, setMessage] = useState<Message>({
    type: undefined,
    msg: ""
  });
  const [disabled, setDisabled] = useState(false)
  const { auth } = useSelector((state: any) => {
    return state;
  });
  const { register, errors } = useForm();
  const url = ADD_PRODUCT_URL;

  const saveToLocalStorage = (data) => {
    storeDataLocally(data, 'products', auth.token);
    setMessage({
      type: "info",
      msg: "Your internet is unstable but your data is safe"
    });
    clearData();
    // analytics().logEvent('added-product-offline');
  };

  const clearData = () => {
    setProduct({
      name: "",
      brand: "",
      category: "",
      price: ""
    });
  };

  const submitData = (e: React.FormEvent) => {
    e.preventDefault();
    setDisabled(true)
      const data = new FormData();

        data.append('name', product.name);
        data.append('brand', product.brand);
        data.append('category', product.category);
        data.append('price', product.price);
        data.append('image', image)
    if (navigator.onLine) {
      axios.post(url, data, {
        headers: { 
        'Authorization': `Bearer ${auth.token}`,
      },
    }).then(() => {
        clearData();
        setMessage({
          type: "success",
          msg: "Data has been added successfully"
        });
        setDisabled(false)
      })
    .catch((error) => {
      setMessage({
        type: "error",
        msg:   `Could not add product please try again`
      })
      setDisabled(false)
    })
      // analytics().logEvent('added-product-online');
    } else {
      setDisabled(false)
      saveToLocalStorage(data);
    }
  }

  const onChangeHandler = (e: React.ChangeEvent) => {
    const { name, value } = e.currentTarget as HTMLInputElement;
    setProduct((data) => ({
      ...data,
      [name]: value
    }));
  };

  const handleImageChange = (e) => {
    setImage(e.target.files[0])
  }

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Appbar title="Add Product"/>
      <main className={classes.main}>
      <Grid container>
        <Grid xs={12} sm={2} item/>
        <Grid xs sm={10} item>
      <Paper className={classes.paper}>
      <div className={classes.contentWrapper}>
        {message.msg !== "" && (
          <Alert severity={message.type}>{message.msg}</Alert>
        )}
        <Typography>
            Please fill all fields
          </Typography>
        
          <form onSubmit={(e) => submitData(e)}>
            <Grid container spacing={3}>
              {productInfo.map((field, i) => (
                <Grid item xs={12} sm={6} key={i}>
                  <TextField
                    id={field.name}
                    name={field.name}
                    label={field.label}
                    margin="normal"
                    fullWidth
                    inputRef={register({ required: field.required })}
                    onChange={(e) => onChangeHandler(e)}
                  />
                </Grid>
              ))}
              <Grid item xs={12} sm={6}>
                <input
                  accept="image/png, image/jpeg"
                  className={classes.input}
                  name="productImage"
                  id="product-image"
                  multiple
                  type="file"
                  onChange={handleImageChange}
                  required
                />
                <label htmlFor="product-image">
                <Button variant="outlined" color="primary" component="span" startIcon={<CloudUploadIcon />}>
                  Upload product image
                </Button>
              </label>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth
                  type="submit"
                  disabled={disabled}
                >
                  Add Product
                </Button>
              </Grid>
            </Grid>
          </form>
        </div>           
      </Paper>
      </Grid>
      </Grid>
      </main>
    </div>
  );
};

export default AddProduct;
